import Vue from 'vue'
import worklogReportApi from '@/api/worklogReport.api'

const state = {
  worklogReports: {}
}


const getters = {
  worklogReport: (state) => (year, month) => {
    return state.worklogReports[`${year}-${month}`] || []
  },

  worklogReportLoaded: (state) => (year, month) => {
    return state.worklogReports[`${year}-${month}`] !== undefined
  }
}


const actions = {
  async loadWorklogReport ({ commit, rootState }, { year, month }) {
    const response = await worklogReportApi.getWorklogReport(rootState.tenant.current, year, month)
    commit('SET_WORKLOG_REPORT', response.data)
  },

  async acceptWorklogReport ({ commit, rootState }, { contactId, year, month }) {
    const response = await worklogReportApi.acceptWorklogReport(rootState.tenant.current, contactId, year, month)
    commit('SET_WORKLOG_REPORT_STATUS', response.data)
  },

  async unacceptWorklogReport ({ commit, rootState }, { contactId, year, month }) {
    const response = await worklogReportApi.unacceptWorklogReport(rootState.tenant.current, contactId, year, month)
    commit('SET_WORKLOG_REPORT_STATUS', response.data)
  }
}


const mutations = {
  SET_WORKLOG_REPORT (state, { contacts, year, month }) {
    Vue.set(state.worklogReports, `${year}-${month}`, contacts)
  },

  SET_WORKLOG_REPORT_STATUS (state, { contactId, year, month, statusId }) {
    const reports = state.worklogReports[`${year}-${month}`]

    if (reports) {
      const report = reports.find(x => x.contactId === contactId)
      if (report) {
        report.statusId = statusId
      }
    }
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
